import { useMemo } from "react";
import { useKeyAction } from "hooks/useKeyAction";
import { useKeyPressed } from "hooks/useKeyPressed/useKeyPressed";
import { resolveCreationModifier } from "./utils";
import type {
  UseCreationModifierKeysArgs,
  UseCreationModifierKeysResult,
} from "./types";

export const useCreationModifierKeys = ({
  isCreationMode,
  isEditingElement,
  isMultiAddModeEnabled,
  onEscape,
}: UseCreationModifierKeysArgs): UseCreationModifierKeysResult => {
  const isCtrlPressed = useKeyPressed({
    code: "ControlLeft",
    isDisabled: !isCreationMode,
  });

  const isCtrlRPressed = useKeyPressed({
    code: "ControlRight",
    isDisabled: !isCreationMode,
  });

  const isMetaPressed = useKeyPressed({
    code: "MetaLeft",
    isDisabled: !isCreationMode,
  });

  const isShiftPressed = useKeyPressed({
    code: "ShiftLeft",
    isDisabled: !isCreationMode,
  });

  const isCtrlLikePressed = isCtrlPressed || isCtrlRPressed || isMetaPressed;

  useKeyAction({
    code: "Escape",
    callback: onEscape,
    options: { isDisabled: !isEditingElement && !isMultiAddModeEnabled },
  });

  const creationModifier = useMemo(
    () =>
      resolveCreationModifier({
        isEditingElement,
        isMultiAddModeEnabled,
        isCtrlLikePressed,
        isShiftPressed,
      }),
    [
      isEditingElement,
      isMultiAddModeEnabled,
      isCtrlLikePressed,
      isShiftPressed,
    ],
  );

  return { creationModifier };
};
